import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { ProductPriceListConversion, UnitOfMeasure } from '../../../models';
import { TmsWebBaseEditService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class UnitOfMeasureService extends TmsWebBaseEditService<UnitOfMeasure, UnitOfMeasure> {
  public refreshDetails = new Subject<void>();

  constructor() {
    super('UnitOfMeasure', $localize`Unit of Measure`);
  }

  checkAlternateUnitOfMeasure(
    id: string,
    productTypeId: string,
    unitOfMeasureId: string,
  ): Observable<ProductPriceListConversion> {
    return this.httpService.get<ProductPriceListConversion>(
      `${this.apiUrl}/CheckAlternateUnitOfMeasure?purchaseContractLineId=${id}&productTypeId=${productTypeId}&unitOfMeasureId=${unitOfMeasureId}`,
    );
  }
}
